import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { UserBasedOperatorData } from "../../config/tableConfigs";
import UserBasedOperatorFormModal from "./components/UserBasedOperatorFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const UserBasedOperatorPage = () => {
  const [modalShow, setModalShow]     = useState(false);
  const [modalMode, setModalMode]     = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]         = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/user_based_operator_action",
    UserBasedOperatorData,
    formdata,
    refresh
  );

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const handleView = (row) => {
    console.log("Viewing:", row);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteUserBasedOperator");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting:", selectedIds);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={UserBasedOperatorData}
        handleOnclick={handleAddUser}
        buttonTitle="Add User Based Operator"
      >
        <DataTable
          config={UserBasedOperatorData}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <UserBasedOperatorFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deleteUserBasedOperator"
        title="Delete User Based Operator"
        message="Are you sure you want to delete this record?"
        apiUrl="https://pro.mokshiq.in/user_based_operator_action"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default UserBasedOperatorPage;